export const host = "http://fotoredaktor.dvizh.net/";

export default async function(url, params = {}){
    const request = await fetch(host+url, params);
    return await request.json();
}
